import { css } from 'styled-components';
import colors from './colors';

export const aiManagementMenuSurface = css`
  min-width: 220px;
  padding: 6px;
  border: 1px solid ${colors.$gray200};
  border-radius: 8px;
  box-shadow: 0 4px 16px ${colors.$black}1f;
`;

export const aiManagementMenuItems = css`
  .dropdown-item {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;

    &:hover,
    &:focus {
      background: ${colors.$gray100};
    }

    &.text-danger:hover,
    &.text-danger:focus {
      background: ${colors.$danger_light_bg};
    }
  }

  .dropdown-divider {
    margin: 6px 0;
    border-top-color: ${colors.$gray200};
  }
`;
